<template>
  <div>
    <!--Breadcrumbs-->
    <transition name="view">


      <!--Leads-->
      <Breadcrumbs v-if="$route.name === 'Leads'" :title="getTranslations('expression_35')"
        :subtitle="getTranslations('expression_91')" class="">
        <!-- essa classe conflita o padding e margin do breadcrumbd de lead -->
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <!-- Mobile buttons with similar styling but smaller -->
            <button v-b-tooltip.bottom v-if="me.data.role_key > 0" :title="getTranslations('expression_109')"
              data-toggle="modal" data-target="#importLeads" @click.prevent="checkImportLeads"
              class="action-btn action-btn-default action-btn-mobile">
              <i class="bx bx-upload"></i>
            </button>
                   <!-- Filter Popover-->
                   <FilterPopover :leads="leads" :channels="channels" :configs="configs" :getTranslations="getTranslations"
              :getTagsArray="getTagsArray" @search-leads="searchLeads" @set-loading="isLoadingLeads = $event" />
            <div>
              <button v-if="getLeadsChannelsBoolean()" v-b-tooltip.bottom class="action-btn action-btn-default"
                @click="openModal">
                <i class="bx bx-plus"></i>
                
              </button>

              <ModalAddLead :isVisible="isopenModalVisible" @close="closeModal" />
            </div>
            <button v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchLeadsModal" class="action-btn action-btn-default action-btn-mobile">
              <i class="bx bx-search"></i>
            </button>
            <button v-b-tooltip.bottom :title="getTranslations('expression_112')" @click.prevent="exportLeads"
              v-if="me.data.role_key > 0 && leads.filter_leads_active && leads.pagination.data && leads.pagination.data.length > 0"
              class="action-btn action-btn-default action-btn-mobile">
              <i class="bx bx-file"></i>
            </button>
          </div>

          <!--Desktop-->
          <div v-else class="d-flex hidden-sm action-buttons-container">
            <!-- Search input -->
            <div class=" mr-3">
              <div class="search-container" :class="{ 'is-active': isActive }">
                <div class="search-icon" @click="toggleSearch">
                  <i class="bx bx-search"></i>
                </div>
                <input ref="searchInput" type="text" v-model="searchTermLeads" @input="handleSearchLeads"
                  @blur="handleBlur" :placeholder="getTranslations('expression_128')" class="search-input" />
                <div class="search-close" v-if="isActive && searchTermLeads" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </div>
              </div>
            </div>

            <!-- Filter Popover-->
            <FilterPopover :leads="leads" :channels="channels" :configs="configs" :getTranslations="getTranslations"
              :getTagsArray="getTagsArray" @search-leads="searchLeads" @set-loading="isLoadingLeads = $event" />

            <!-- Add new button -->

            <div>
              <button v-if="getLeadsChannelsBoolean()" v-b-tooltip.bottom class="action-btn action-btn-default"
                @click="openModal">
                <i class="bx bx-plus"></i>
                <span>{{ getTranslations('expression_110') }}</span>
              </button>

              <ModalAddLead :isVisible="isopenModalVisible" @close="closeModal" />
            </div>


            <!-- Import button (primary) -->
            <button v-b-tooltip.bottom v-if="me.data.role_key > 0" data-toggle="modal" data-target="#importLeads"
              @click.prevent="checkImportLeads" class="action-btn action-btn-primary">
              <i class="bx bx-upload"></i>
              <span>{{ getTranslations('expression_109') }}</span>
            </button>

            <!-- Export button -->
            <button v-b-tooltip.bottom @click.prevent="exportLeads"
              v-if="me.data.role_key > 0 && leads.filter_leads_active && leads.pagination.data && leads.pagination.data.length > 0"
              class="action-btn action-btn-default">
              <i class="bx bx-file"></i>
              <span>{{ getTranslations('expression_112') }}</span>
            </button>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'Lead'" :title="getTranslations('expression_93')"
        :subtitle="getTranslations('expression_92')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <router-link :to="{ name: 'Leads' }" class="d-flex animated--fade-in" style="text-decoration: none;">
            <span :class="($mq === 'mobile' || $mq === 'tablet') ? ' pr-0' : ''" class="btn-back">
              <i class="bx bx-chevron-left mt-1 p-0 mr-2"></i> {{ getTranslations('expression_113') }}
            </span>
          </router-link>
        </div>
      </Breadcrumbs>



<!-- Chat Breadcrumb -->
<Breadcrumbs
  v-if="$route.name === 'Chat'"
  :title="'Chat'"
  :subtitle="getTranslations('expression_1490')" 
>
  <template #action>
    <ChatSearchInput
      v-model="searchQuery"
      placeholder="Buscar conversas..."
      @keyup.enter="handleSearch"
    />
  </template>
</Breadcrumbs>














      <!--Users-->
      <Breadcrumbs v-if="$route.name === 'Users' && me.data.role_key > 0" :title="getTranslations('expression_82')"
        :subtitle="getTranslations('expression_94')" class="pt-1 pb-2 pr-1 padding-sm-2">

        <div slot="action" class="action-buttons-container d-flex align-items-center">

          <!-- Botões Ícones Mobile (apenas ícones) -->
          <div class="d-flex d-md-none">
            <span v-b-tooltip.bottom :title="getTranslations('expression_115')" data-toggle="modal"
              data-target="#addUser" v-if="!isTester() || (isTester() && users.pagination.total < 3)"
              class="action-btn action-btn-icon action-btn-mobile">
              <i class="bx bx-plus"></i>
            </span>

            <div class=" mr-3">
              <div class="search-container" :class="{ 'is-active': isActive }">
                <div class="search-icon" @click="toggleSearch">
                  <i class="bx bx-search"></i>
                </div>
                <input ref="searchInput" type="text" v-model="searchTermUsers" @input="searchUsers" @blur="handleBlur"
                  :placeholder="getTranslations('expression_114')" class="search-input" />
                <div class="search-close" v-if="isActive && searchTermUsers" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Botões Desktop (com texto e ícones) -->
          <div class="d-none d-md-flex align-items-center">
            <small class="mr-4 badge-rounded">
              {{ users.pagination.total }}
              {{ users.pagination.total > 1 ? getTranslations('expression_116') : getTranslations('expression_117') }}
            </small>

            <div class=" mr-3">
              <div class="search-container" :class="{ 'is-active': isActive }">
                <div class="search-icon" @click="toggleSearch">
                  <i class="bx bx-search"></i>
                </div>
                <input ref="searchInput" type="text" v-model="searchTermUsers" @input="searchUsers" @blur="handleBlur"
                  :placeholder="getTranslations('expression_114')" class="search-input" />
                <div class="search-close" v-if="isActive && searchTermUsers" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </div>
              </div>
            </div>

            <button v-b-tooltip.bottom data-toggle="modal" data-target="#addUser"
              v-if="!isTester() || (me.data.role_key > 0 && isTester()) || (isTester() && users.pagination.total < channels.data[0].plan[8].amount)"
              class="btn-custom mr-1">
              {{ getTranslations('expression_115') }}
            </button>
          </div>

        </div>
      </Breadcrumbs>

      <Breadcrumbs v-if="$route.name === 'User'" :title="getTranslations('expression_95')"
        :subtitle="getTranslations('expression_96')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action" v-if="me.data.role_key > 0">
          <!-- BACK TO USERS LIST -->
           <button @click.prevent="$router.push({name: 'Users'})" class="btn-back">
              <i class="fi fi-rr-angle-small-left"></i>
              {{ getTranslations('expression_113') }}
            </button>
        </div>
      </Breadcrumbs>



      <!-- title e subtitle -->
      <!--Channels-->
      <Breadcrumbs v-if="$route.name === 'Channels' && me.data.role_key > 0" :title="getTranslations('expression_5')"
        :subtitle="getTranslations('expression_97')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">

            <button v-if="me.data.role_key > 0" @click="openModal" class="btn-custom mr-1">
              {{ getTranslations('expression_118') }}
            </button>

            <!-- Passa `isopenModalVisible` como prop e escuta o evento de fechamento -->
            <StepByStepModal :isVisible="isopenModalVisible" @close="closeModal" />
            <div class=" mr-3">
              <div class="search-container" :class="{ 'is-active': isActive }">
                <div class="search-icon" @click="toggleSearch">
                  <i class="bx bx-search"></i>
                </div>
                <input ref="searchInput" type="text" v-model="searchTermUsers" @input="searchUsers" @blur="handleBlur"
                  :placeholder="getTranslations('expression_114')" class="search-input" />
                <div class="search-close" v-if="isActive && searchTermUsers" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </div>
              </div>
            </div>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              channels.pagination.total > 1
              ? `${channels.pagination.total} ${getTranslations('expression_116')}`
              : `${channels.pagination.total} ${getTranslations('expression_117')}`
              }}
            </small>




            <!-- Campo de busca estilizado -->
            <div class=" mr-3">
              <div class="search-container" :class="{ 'is-active': isActive }">
                <div class="search-icon" @click="toggleSearch">
                  <i class="bx bx-search"></i>
                </div>
                <input ref="searchInput" type="text" v-model="searchTermChannel" @input="searchChannel"
                  @blur="handleBlur" :placeholder="getTranslations('expression_119')" class="search-input" />
                <div class="search-close" v-if="isActive && searchTermChannel" @click="clearSearch">
                  <i class="bx bx-x"></i>
                </div>
              </div>
            </div>
            <!-- Botão de adicionar canal -->
            <div>
              <!-- Botão para abrir o modal -->
              <button v-if="me.data.role_key > 0" @click="openModal" class="btn-custom mr-1">
                {{ getTranslations('expression_118') }}
              </button>

              <!-- Passa `isopenModalVisible` como prop e escuta o evento de fechamento -->
              <StepByStepModal :isVisible="isopenModalVisible" @close="closeModal" />

            </div>

            <!-- Nesse Button abaixo ele possui um :title que mostra o titulo ao passar o mouse -->
            <!-- <button  
    v-if="me.data.role_key > 0"
    v-b-tooltip.bottom
    :title="getTranslations('expression_118')"
    data-toggle="modal"
    data-target="#addChannel"
    class="btn-custom mr-1">
    {{ getTranslations('expression_118') }}
  </button> -->



          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="!($mq === 'mobile' || $mq === 'tablet') && $route.name === 'Channel' && me.data.role_key > 0"
        icon="bx bx-mobile-alt" :title="getTranslations('expression_4')" :subtitle="getTranslations('expression_98')"
        :text="`${channels.channel.name}`" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <span class="d-flex animated--fade-in" style="text-decoration: none;">
            <!-- BACK TO CHANNELS LIST -->
            <button @click.prevent="$router.push({name: 'Channels'})" class="btn-back">
              <i class="fi fi-rr-angle-small-left"></i>
              {{ getTranslations('expression_113') }}
            </button>


            <!-- BACK TO CHANNELS LIST -->

            <!-- SAVE CHANGES IN CHANNEL -->
            <button @click.prevent="saveChannel" class="btn-save">
              <i class="bx bx-save mr-2"></i>
              {{ getTranslations('expression_120') }}
            </button>
            <!-- SAVE CHANGES IN CHANNEL -->
          </span>
        </div>
      </Breadcrumbs>





      <Breadcrumbs v-if="$route.name === 'Campaign' && me.data.role_key > 0" :title="getTranslations('expression_100')"
        :subtitle="getTranslations('expression_101')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
            <button @click.prevent="$router.push({name: 'Campaigns'})" class="btn-back">
              <i class="fi fi-rr-angle-small-left"></i>
              {{ getTranslations('expression_113') }}
            </button>

          <!-- <router-link :to="{ name: 'Campaigns' }" class="d-flex animated--fade-in" style="text-decoration: none;">
            <span :class="($mq === 'mobile' || $mq === 'tablet') ? ' pr-0' : ''" class="btn-back">
              <i class="bx bx-chevron-left mt-1 p-0 mr-2"></i>
              {{ getTranslations('expression_113') }}
            </span>
          </router-link> -->
        </div>
      </Breadcrumbs>

      <!--Reports -->
      <Breadcrumbs v-if="$route.name === 'Reports'" :title="getTranslations('expression_59')"
        :subtitle="getTranslations('expression_1317')"></Breadcrumbs>

<Breadcrumbs
  v-if="$route.name === 'ReportsCampaignPerformance'"
  title="Desempenho da Campanha"
  subtitle="Acompanhe e analise os resultados dos seus disparos de campanha."
  icon="bx bx-bar-chart-square"
/>




      <Breadcrumbs v-if="$route.name === 'ReportsCampaigns' && me.data.role_key > 0"
        :title="getTranslations('expression_103')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile e Desktop-->
          <div class="d-flex row pt-2">
            <!--Canal-->
            <div class="col-4 pr-4">
              <div class="input-group" v-b-tooltip.bottom :title="getTranslations('expression_6')"
                style="margin-top: 8px">
                <select @change="setEngagement('channel_select'), configs.report_tab = 1"
                  v-model="leads.reports.channel_id" style="min-width: 150px;
                                    font-size: 0.9rem;
                                    padding: .3rem 0;" class="input_forms custom-select px-1 bg-transparent">
                  <option :value="null">{{ getTranslations('expression_6') }}</option>
                  <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                    {{ channel.name }}
                  </option>
                </select>
              </div>
            </div>
            <!--Opt-In-->
            <div v-if="leads.reports.channel_id" class="col-4">
              <div @click.prevent="setEngagement(1)" v-b-tooltip.bottom
                :title="($mq === 'mobile' || $mq === 'tablet') ? 'Leads Opt-In' : ''"
                :class="configs.report_tab === 1 ? 'btn-primary' : 'bg-white'"
                class="shadow-sm cursor_pointer animated--grow-in py-2 px-3">
                <i class="bx bx-user-plus"></i>
                <span class="ml-2 hidden-sm">Opt-In</span>
              </div>
            </div>
            <!--Opt-Out-->
            <div v-if="leads.reports.channel_id" class="col-4">
              <div @click.prevent="setEngagement(2)" v-b-tooltip.bottom
                :title="($mq === 'mobile' || $mq === 'tablet') ? 'Leads Opt-Out' : ''"
                :class="configs.report_tab === 2 ? 'btn-primary' : 'bg-white'"
                class="shadow-sm cursor_pointer animated--grow-in py-2 px-3">
                <i class="bx bx-user-minus"></i>
                <span class="ml-2 hidden-sm">Opt-Out</span>
              </div>
            </div>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsOperatorsLeads' && me.data.role_key > 0"
        :title="getTranslations('expression_105')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile e Desktop-->
          <div class="d-flex">
            <div v-if="!($mq === 'mobile' || $mq === 'tablet')" class="row hidden-sm pt-1">
              <div class="col">
                <div class="input-group mb-2" v-b-tooltip.bottom :title="getTranslations('expression_6')">
                  <select @change="operators.reports.department_id = null; setChannel();"
                    v-model="operators.reports.channel_id" style="min-width: 170px; padding-right: 35px!important;"
                    class="input_forms custom-select px-1 bg-transparent">
                    <option :value="null">{{ getTranslations('expression_9') }}</option>
                    <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                      {{ channel.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="operators.reports.channel_id" class="col">
                <div class="input-group mb-2" v-b-tooltip.bottom :title="getTranslations('expression_125')">
                  <select @change="setOperatorDepartment" v-model="operators.reports.department_id"
                    style="min-width: 230px; padding-right: 35px!important;"
                    class="input_forms custom-select px-1 bg-transparent">
                    <option :value="null">{{ getTranslations('expression_124') }}</option>
                    <option v-for="department in getDepartmentsArray('channel_id', operators.reports.channel_id)"
                      :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="operators.reports.department_id" class="col">
                <div class="input-group mb-2" v-b-tooltip.bottom :title="getTranslations('expression_126')">
                  <select @change="setOperatorReport" v-model="operators.reports.operator_id"
                    style="min-width: 170px; padding-right: 35px!important;"
                    class="input_forms custom-select px-1 bg-transparent">
                    <option :value="null">{{ getTranslations('expression_127') }}</option>
                    <option v-for="operator in getOperatorsArray('department_id', operators.reports.department_id)"
                      :key="operator.id" :value="operator.id">
                      {{ getUserObject('id', operator.user_id).name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="operators.reports.channel_id" class="pl-3">
              <span @click.prevent="exportOperatorsReportsExcel" :title="getTranslations('expression_122')"
                class="btn btn-white rounded-circle pr-0 mr-0">
                <i class="bx bxs-file m-0 p-0"></i>
              </span>
            </div>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsTickets'" :title="getTranslations('expression_106')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchTicketModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="requestDownloadHistoriesCsv" v-if="me.data.role_key > 0 && tickets.filter_tickets_active
                  && tickets.tickets_report_pagination.data && tickets.tickets_report_pagination.data.length > 0"
              v-b-tooltip.bottom :title="getTranslations('expression_130')" class="btn btn-white rounded-circle">
              <i class="bx bxs-file-pdf m-0 p-0"> </i>
            </span>
            <span @click.prevent="requestDownloadExcelTickets" v-if="me.data.role_key > 0 && tickets.filter_tickets_active
                  && tickets.tickets_report_pagination.data && tickets.tickets_report_pagination.data.length > 0"
              v-b-tooltip.bottom :title="getTranslations('expression_122')"
              class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small v-if="tickets.filter_active" class="mr-4 align-self-center badge-rounded">
              {{
              tickets.tickets_report_pagination.total > 1
              ? `${tickets.tickets_report_pagination.total} ${getTranslations('expression_116')}`
              : `${tickets.tickets_report_pagination.total} ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchTicketModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="requestDownloadHistoriesCsv" v-if="me.data.role_key > 0 && me.data.role_key > 0 && tickets.filter_tickets_active
                  && tickets.tickets_report_pagination.data && tickets.tickets_report_pagination.data.length > 0"
              v-b-tooltip.bottom :title="getTranslations('expression_130')" class="btn btn-white rounded-circle mr-3">
              <i class="bx bxs-file-pdf m-0 p-0"> </i>
            </span>
            <span @click.prevent="requestDownloadExcelTickets" v-if="me.data.role_key > 0 && tickets.filter_tickets_active
                  && tickets.tickets_report_pagination.data && tickets.tickets_report_pagination.data.length > 0"
              v-b-tooltip.bottom :title="getTranslations('expression_122')"
              class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsWebhooks'" :title="getTranslations('expression_1209')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchWebhookModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              histories.pagination.total > 1
              ? `${histories.pagination.total} ${getTranslations('expression_116')}`
              : `${histories.pagination.total} ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportWebhook" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>

      <Breadcrumbs v-if="$route.name === 'ReportsCampaignTracking' && me.data.role_key > 0"
        :title="getTranslations('expression_1149')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <router-link :to="{ name: 'Campaigns' }" class="d-flex animated--fade-in" style="text-decoration: none;">
            <span :class="($mq === 'mobile' || $mq === 'tablet') ? ' pr-0' : ''" class="btn-back">
              <i class="bx bx-chevron-left mt-1 p-0 mr-2"></i> {{ getTranslations('expression_113') }}
            </span>
          </router-link>
        </div>
      </Breadcrumbs>

      <Breadcrumbs v-if="$route.name === 'ReportsChatbot' && me.data.role_key > 0"
        :title="getTranslations('expression_1258')" class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Desktop-->
          <div class="d-flex">
            <div v-if="($mq !== 'mobile' && $mq !== 'tablet')" class="d-flex pr-3 pt-1">
              <!--Data inicial-->
              <div v-if="reports.filter_report_chatbot.channel_id !== null" v-b-tooltip.bottom
                :title="getTranslations('expression_815')">
                <label class="">{{ getTranslations('expression_814') }} </label>
                <div class="input-group">
                  <input type="date" onclick="this.showPicker()" v-model="reports.filter_report_chatbot.initial_date"
                    class="input_forms custom-select px-1 bg-transparent">
                </div>
              </div>
              <!--Data final-->
              <div v-if="reports.filter_report_chatbot.channel_id !== null" class="mx-4" v-b-tooltip.bottom
                :title="getTranslations('expression_815')">
                <label class="">{{ getTranslations('expression_815') }} </label>
                <div class="input-group">
                  <input type="date" onclick="this.showPicker()" v-model="reports.filter_report_chatbot.final_date"
                    class="input_forms custom-select px-1 bg-transparent">
                </div>
              </div>
              <!--Definir Canal-->
              <div v-b-tooltip.bottom :title="getTranslations('expression_6')">
                <label class="">{{ getTranslations('expression_4') }} </label>
                <select v-model="reports.filter_report_chatbot.channel_id" @change="searchChatbot()"
                  class="input-group input_forms custom-select px-1 bg-transparent">
                  <option :value="null" disabled>{{ getTranslations('expression_7') }}</option>
                  <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                    {{ channel.name }}
                  </option>
                </select>
              </div>
              <!--Pesquisar-->
              <div class="d-flex align-items-end ml-2" v-b-tooltip.bottom :title="reports.filter_report_chatbot.initial_date == null
                                && reports.filter_report_chatbot.final_date == null
                                ? getTranslations('expression_1274') : getTranslations('expression_60')">
                <button v-if="reports.filter_report_chatbot.channel_id !== null"
                  :disabled="reports.filter_report_chatbot.initial_date == null && reports.filter_report_chatbot.final_date == null"
                  @click.prevent="searchChatbot()"
                  class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
                  <i class="bx bx-search m-0 p-0"></i>
                  <span class="">{{ getTranslations('expression_811') }}</span>
                </button>
              </div>
            </div>
            <!--Exportar relatório-->
            <div v-if="($mq === 'mobile' || $mq === 'tablet')">
              <span v-if="me.data.role_key > 0 && reports.filter_report_chatbot.channel_id !== null
                    && reports.report_main_menu_chatbot_clicks.length > 0" @click.prevent="exportChatbotReports"
                v-b-tooltip.bottom :title="getTranslations('expression_122')"
                class="btn btn-white d-flex align-items-end rounded-circle pt-4 pr-1 mr-0">
                <i class="bx bxs-file m-0 p-0"></i>
              </span>
            </div>

            <div v-else class="d-flex align-items-end ml-2">
              <button v-if="me.data.role_key > 0 && reports.filter_report_chatbot.channel_id !== null
                    && reports.report_main_menu_chatbot_clicks.length > 0" @click.prevent="exportChatbotReports"
                :title="getTranslations('expression_122')"
                class="shadow-sm cursor_pointer animated--grow-in btn-success text-white py-2 px-3">
                <i class="bx bxs-file m-0 p-0"></i>
                <span class="">{{ getTranslations('expression_122') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Breadcrumbs>

      <!--TRADUZIR-->
      <Breadcrumbs v-if="$route.name === 'ReportsEmail'" :title="getTranslations('expression_1038')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportEmailModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportEmailsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              histories.pagination.total > 1
              ? `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_116')}`
              : `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportEmailModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportEmailsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsHsm'" :title="getTranslations('expression_1039')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportHsmModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportHsmReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              histories.pagination.total > 1
              ? `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_116')}`
              : `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportHsmModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportHsmReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsNps'" :title="getTranslations('expression_1052')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportNpsModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportNpsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_60')" class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <!--            <small class="mr-4 align-self-center badge-rounded">-->
            <!--              {{ histories.pagination.total > 1-->
            <!--              ? `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')} ${getTranslations('expression_116')}`-->
            <!--              : `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')} ${getTranslations('expression_117')}` }}-->
            <!--            </small>-->
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportNpsModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportNpsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsSms'" :title="getTranslations('expression_1040')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportSmsModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportSmsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              histories.pagination.total > 1
              ? `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_116')}`
              : `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportSmsModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportSmsReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="$route.name === 'ReportsVoip'" :title="getTranslations('expression_1041')"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Mobile-->
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportVoipModal" class="btn btn-white rounded-circle">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportVoipReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-0 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Desktop-->
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              histories.pagination.total > 1
              ? `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_116')}`
              : `${histories.pagination.total ? histories.pagination.total : getTranslations('expression_1116')}
              ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchReportVoipModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span @click.prevent="exportVoipReportsExcel" v-if="me.data.role_key > 0" v-b-tooltip.bottom
              :title="getTranslations('expression_122')" class="btn btn-white rounded-circle pr-1 mr-0">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs>

      <!--Disabled-->
      <Breadcrumbs v-if="false && $route.name === 'ReportsNegotiations' && me.data.role_key > 0"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Desktop-->
          <div class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded">
              {{
              tickets.pagination.total > 1
              ? `${tickets.pagination.total} ${getTranslations('expression_116')}`
              : `${tickets.pagination.total} ${getTranslations('expression_117')}`
              }}
            </small>
            <span v-b-tooltip.bottom :title="getTranslations('expression_60')" data-toggle="modal"
              data-target="#searchTicketModal" class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-search m-0 p-0"></i>
            </span>
            <span v-b-tooltip.bottom title="Compartilhar pesquisa" @click.prevent="copyLink"
              class="btn btn-white rounded-circle mr-3">
              <i class="bx bx-share m-0 p-0"></i>
            </span>
            <span v-b-tooltip.bottom v-if="me.data.role_key > 0" :title="getTranslations('expression_130')"
              class="btn btn-white rounded-circle mr-3">
              <i class="bx bxs-file-pdf m-0 p-0"> </i>
            </span>
            <span v-b-tooltip.bottom :title="getTranslations('expression_122')"
              class="btn btn-white rounded-circle mr-3">
              <i class="bx bxs-file m-0 p-0"></i>
            </span>
          </div>
          <!--Mobile-->
          <div class="hidden-md">
            <span class="btn btn-white" id="reportTickets4MobileDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="bx bx-dots-vertical-rounded bx-sm"></i>
              <!-- Dropdown - User Information -->
              <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                aria-labelledby="reportTickets4MobileDropdown">
                <router-link :to="{ name: 'Home' }" class="dropdown-item">
                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                  {{ getTranslations('expression_41') }}
                </router-link>
                <div class="dropdown-divider"></div>
                <a href="/" class="dropdown-item" type="submit" action="post">
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  {{ getTranslations('expression_37') }}
                </a>
              </div>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <Breadcrumbs v-if="false && $route.name === 'ReportsUsed' && me.data.role_key > 0"
        class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <!--Desktop-->
          <div class="d-flex hidden-sm">
            <span v-b-tooltip.bottom :title="getTranslations('expression_134')"
              class="btn btn-white rounded-circle mr-0 pr-0">
              <i class="bx bx-info-circle m-0 p-0"></i>
            </span>
          </div>
          <!--Mobile-->
          <div class="hidden-md">
            <span class="btn btn-white" id="reportTickets5MobileDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="bx bx-dots-vertical-rounded bx-sm"></i>
              <!-- Dropdown - User Information -->
              <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                aria-labelledby="reportTickets5MobileDropdown">
                <router-link :to="{ name: 'Home' }" class="dropdown-item">
                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                  Perfil
                </router-link>
                <div class="dropdown-divider"></div>
                <a href="/" class="dropdown-item" type="submit" action="post">
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  Sair
                </a>
              </div>
            </span>
          </div>
        </div>
      </Breadcrumbs>
      <!--Tasks-->
      <!-- <Breadcrumbs v-if="$route.name === 'Tasks'"
                   :title="getTranslations('expression_69')"
                   :subtitle="getTranslations('expression_107')"
                   class="pt-1 pb-2 pr-1 padding-sm-2">
        <div slot="action">
          <div v-if="($mq === 'mobile' || $mq === 'tablet')" class="hidden-md d-flex">
            <small class="mr-4 align-self-center badge-rounded"></small>
            <span v-b-tooltip.bottom
                  :title="getTranslations('expression_135')"
                  data-toggle="modal"
                  data-target="#addTask"
                  class="btn btn-white rounded-circle">
              <i class="bx bx-plus m-0 p-0"></i>
            </span>
            <span v-b-tooltip.bottom
                  :title="getTranslations('expression_134')"
                  class="btn btn-white rounded-circle pr-0">
              <i class="bx bx-info-circle m-0 p-0"></i>
            </span>
          </div>
          <div v-else class="d-flex hidden-sm">
            <small class="mr-4 align-self-center badge-rounded"></small>
            <span v-b-tooltip.bottom
                  :title="getTranslations('expression_135')"
                  data-toggle="modal"
                  data-target="#addTask"
                  class="btn btn-white rounded-circle mr-2">
              <i class="bx bx-plus m-0 p-0"></i>
            </span>
            <span v-b-tooltip.bottom
                  :title="getTranslations('expression_134')"
                  class="btn btn-white rounded-circle">
              <i class="bx bx-info-circle m-0 p-0"></i>
            </span>
          </div>
        </div>
      </Breadcrumbs> -->
    </transition>
  </div>
</template>

<script>
import Breadcrumbs from "../../components/theme/Breadcrumbs";
import { mapGetters, mapState } from "vuex";
import FilterPopover from "./FilterPopover.vue";
import StepByStepModal from "../../components/general/StepByStepModal.vue";
import ModalAddLead from '../../components/modals/ModalAddLead.vue';
import "../../../js/assets/css/Breadcrumb.css"
import ChatSearchInput from "../chat/ChatSearchInput.vue";
export default {
  name: "Breadcrumb",
  components: {
    ModalAddLead,
    FilterPopover,
    ChatSearchInput,
    Breadcrumbs,
    StepByStepModal,
  },
  
  data() {
    return {
          searchQuery: '',
      isFilterMenuOpen: false,
      isopenModalVisible: false,
      date_on_filter_tickets_empty: false,
      date_on_filter_tickets_greather_than_31_days: false,
      searchTermChannel: "",
      searchTermUsers:"",
      searchTermLeads: "",
      isActiveLeads: false,
    isActiveUsers: false,
    isActiveChannel: false,
      isActive: false,
      clickOutsideHandler: null
    }
  },
  computed: {
    ...mapState([
      'channels', 'leads', 'goals', 'tasks', 'me', 'departments',
      'operators', 'configs', 'users', 'tickets', 'campaigns',
      'sources', 'dashboard', 'tags', ' chat'
      
    ]),
    ...mapGetters([
      'getUsersArray', 'getDepartmentsArray', 'getUserObject',
      'getChannelsArray', 'getOperatorsArray', 'getLeadsChannelsBoolean',
      'getChannelObject',
      'getTagObject',
      'getTagsArray',
      'getLeadTagObject',
      'getDepartmentObject',
      'getLeadTagsArray',
      'getOperatorObject',
      
    ])
  },
  mounted() {
    this.isopenModalVisible = false;
    
   
    this.clickOutsideHandler = (event) => {
      if (this.isFilterMenuOpen && 
          this.$refs.filterBtn && 
          !this.$refs.filterBtn.contains(event.target) && 
          !event.target.closest('.filter-popover')) {
        this.isFilterMenuOpen = false;
      }
    };
    
    document.addEventListener('click', this.clickOutsideHandler);
  },
  
  beforeDestroy() {
    
    document.removeEventListener('click', this.clickOutsideHandler);
  },

  methods: {
    handleSearch(query) {
    this.searchTriggered = true;
    this.$store.dispatch('searchTickets', query).catch(() => {});
    console.log('Busca realizada:', query);
  },
    setEngagement() {
      if (this.leads.reports.channel_id) {
        this.$store.dispatch("getLeadsReportsEngagementInGraph", {channel_id: this.leads.reports.channel_id})
        this.$store.dispatch("getLeadsReportsEngagementOutGraph", {channel_id: this.leads.reports.channel_id})
      }
    },
    handleSearchLeads() {
  this.$store.dispatch("setLeadsLoading", true);

  clearTimeout(this.searchDebounceTimeout);
  this.searchDebounceTimeout = setTimeout(() => {
    this.searchLeads().finally(() => {
      this.$store.dispatch("setLeadsLoading", false);
    });
  }, 1000);
},
    // buscar Leads com o termo digitado
    async searchLeads() {
      this.leads.search_lead.page = 1;
     
      const term = this.searchTermLeads.trim();

     
      this.leads.search_lead.name = "";
      this.leads.search_lead.email = "";
      this.leads.search_lead.phone = "";

     
      if (term.includes("@")) {
        this.leads.search_lead.email = term;
      } else if (/^\d+$/.test(term)) {
        this.leads.search_lead.phone = term;
      } else {
        this.leads.search_lead.name = term;
      }
      this.$store.dispatch("setLeadsLoading", true);


      // console.log("Filtro aplicado:", {
      //   nome: this.leads.search_lead.name,
      //   email: this.leads.search_lead.email,
      //   telefone: this.leads.search_lead.phone
      // });
      try {
        await this.$store.dispatch("getLeads", this.leads.search_lead);
        await this.$store.dispatch("getLeadsInfo", this.leads.search_lead);

        this.leads.filter_leads_active = true;

        if (!this.leads.pagination || !this.leads.pagination.data.length) {
          console.warn("Nenhum lead encontrado com os filtros atuais.");
        }
      } catch (error) {
        console.error("Erro ao buscar leads:", error);
      } finally {
        this.$store.dispatch("setLeadsLoading", false);
      }
    },

    // Aplicar filtros do dropdown
    // async applyFilters() {
    //   // Certifique-se de que os filtros estão aplicados corretamente
    //   await this.$store.dispatch("getLeads", this.leads.search_lead);
    //   await this.$store.dispatch("getLeadsInfo", this.leads.search_lead);

    //   this.isFilterMenuOpen = false; // Fecha o menu após aplicar os filtros
    // },

    // Limpar todos os filtros e recarregar os leads
    // clearFilters() {
    //   this.leads.search_lead = {
    //     name: "",
    //     phone: "",
    //     email: "",
    //     office: "",
    //     company: "",
    //     status_key: null,
    //     channel_id: null,
    //     start_date: null,
    //     final_date: null,
    //     newsletter_key: null,
    //     tags_id: []
    //   };
    //   this.searchLeads();
    //   this.isFilterMenuOpen = false;
    // },

    // Abrir e fechar barra de pesquisa
    toggleSearch() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },

    // Fechar barra de pesquisa quando perder o foco
    handleBlur() {
      if (!this.searchTermLeads) {
        this.isActive = false;
      }
    },

    // Limpar campo de busca
    clearSearch() {
  this.searchTermLeads = '';
  this.searchLeads();
  
  this.searchTermUsers = '';
  this.searchUsers();

  this.searchTermChannel = '';
  this.searchChannel();

  this.handleSearchLeads();
    },
    
    
    searchChannel() {
      if (this.searchTermChannel.trim() !== "") {
        this.$store.dispatch("getChannels", {
          ...this.channels.search_channel,
          name: this.searchTermChannel,
          
        });
      } else {
        this.$store.dispatch("getChannels");
      }
    },
    
    searchUsers() {
      if (this.searchTermUsers.trim() !== "") {
        const isEmail = this.searchTermUsers.includes("@");

        const payload = isEmail
          ? { email: this.searchTermUsers }  
          : { name: this.searchTermUsers }; 
          
        this.$store.dispatch("searchUsers", payload);
      } else {
        this.$store.dispatch("getUsers");
      }
    },
    
    openModal() {
      this.isopenModalVisible = true;
    },

    closeModal() {
      this.isopenModalVisible = false;
    },

    saveChannel() {
      this.$store.dispatch("updateChannel", this.channels.channel);
      this.channels.plan_edit.status = 1;
      if (this.departments.department.id && this.departments.department.id > 0) {
        let department = {
          id: this.departments.department.id,
          channel_id: this.departments.department.channel_id,
          business_hours: this.departments.department.business_hours
        };
        this.$store.dispatch("updateDepartment", department);
      }
    },

    copyLink() {
      this.$swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Link copiado com sucesso!',
        showConfirmButton: false,
        timer: 1500
      });
    },

    createCampaignButton() {
      this.$router.push({ name: 'Campaign' });
    },

    exportLeads() {
      this.$store.dispatch('exportLeads', this.leads.search_lead);
    },

    addCampaign() {
      this.$router.push({ name: 'Campaign' });
    },

    openXLS() {
      window.open(`/media/example.xls`, '_blank');
    },

    openUrl(payload) {
      window.open(`${payload}`, '_blank');
    },

    checkImportLeads() {
      this.$store.dispatch('checkUploadLeads');
    },

    requestDownloadHistoriesCsv() {
      this.$store.dispatch('exportCsvHistories', this.tickets.search_ticket);
    },

    requestDownloadExcelTickets() {
      this.validateFilterToExportTickets();
      if (this.date_on_filter_tickets_empty || this.date_on_filter_tickets_greather_than_31_days) {
        this.$swal.fire({
          position: 'center',
          icon: 'info',
          text: 'Para exportar as conversas, é permitido somente um período de até 31 dias. Por favor, faça o filtro de Data Inicial e Data Final com base nesse limite',
          showConfirmButton: true
        }).then(result => {
          if (result.isConfirmed) {
            $('#searchTicketModal').modal('show');
          }
        });
      } else {
        this.$store.dispatch('exportExcelTickets', this.tickets.search_ticket);
      }
    },

    validateFilterToExportTickets() {
      this.date_on_filter_tickets_empty = false;
      this.date_on_filter_tickets_greather_than_31_days = false;
      let start_date = this.tickets.search_ticket.start_date;
      let final_date = this.tickets.search_ticket.final_date;

      if (['', null, undefined].includes(start_date) || ['', null, undefined].includes(final_date)) {
        this.date_on_filter_tickets_empty = true;
      }

      if (!this.date_on_filter_tickets_empty) {
        let start_date_time = new Date(start_date);
        let final_date_time = new Date(final_date);
        let difference_in_days = Math.round((final_date_time - start_date_time) / (1000 * 60 * 60 * 24));

        if (difference_in_days > 31) {
          this.date_on_filter_tickets_greather_than_31_days = true;
        }
      }
    },

    exportEmailsReportsExcel() {
      this.$store.dispatch('exportEmailsExcel', this.histories.search_email);
    },

    exportSmsReportsExcel() {
      this.$store.dispatch('exportSmsExcel', this.histories.search_sms);
    },

    exportHsmReportsExcel() {
      this.$store.dispatch('exportHsmExcel', this.histories.search_hsm);
    },

    exportNpsReportsExcel() {
      this.$store.dispatch('exportNpsExcel', this.histories.search_nps);
    },

    exportVoipReportsExcel() {
      this.$store.dispatch('exportVoipExcel', this.histories.search_voip);
    },

    exportChatbotReports() {
      this.$store.dispatch('getReportExportChatBot', this.reports.filter_report_chatbot);
    },

    setDepartment() {
      this.tickets.funnels.search.operator_id = null;
    },

    setChannel() {
      if (this.operators.reports.channel_id != null) {
        this.operators.reports.operator_id = null;
        this.operators.reports.department_id = null;
        this.$store.dispatch('getOperatorsInfo');
        this.$store.dispatch('getOperatorsReport');
      }
    },

    startDashboard() {
      if (this.channels.data) {
        if (this.channels.data[0] && this.channels.data[0].id !== undefined) {
          this.dashboard.channel_id = this.channels.data[0].id;
          this.setChannelDashboard();
        } else {
          setTimeout(() => {
            this.startDashboard();
          }, 50);
        }
      }
    },

    setChannelDashboard() {
      if (this.dashboard.channel_id > 0) {
        if (this.$route.name !== 'Lead' && this.$route.name !== 'ReportsTickets') {
          this.$store.dispatch('getTickets', {
            status_key: [0, 1, 2, 3, 4, 5, 11],
            channel_id: this.dashboard.channel_id,
            per_page: 10
          });
        }
        this.$store.dispatch('getDashboardInfo', {
          channel_id: this.dashboard.channel_id
        });
        this.$store.dispatch('getDashboardChartPie', {
          channel_id: this.dashboard.channel_id
        });
      }
    },

    setOperatorDepartment() {
      this.operators.reports.operator_id = null;
      this.$store.dispatch('getOperatorsInfo');
      this.$store.dispatch('getOperatorsReport');
    },

    setOperatorReport() {
      this.$store.dispatch('getOperatorsInfo');
      this.$store.dispatch('getOperatorsReport');
    },

    async setEngagement(engagement_type) {
      if (this.leads.reports.channel_id) {
        // Lógica para quando a ação for a seleção de um canal
        if (engagement_type === 'channel_select') {
          await this.$store.dispatch("getLeadsReportsEngagementIn", {channel_id: this.leads.reports.channel_id})
          await this.$store.dispatch("getLeadsReportsEngagementInGraph", {channel_id: this.leads.reports.channel_id})
          /*await this.$store.dispatch("getLeadsReportsEngagementOut")
          await this.$store.dispatch("getLeadsReportsEngagementOutGraph", {channel_id: this.leads.reports.channel_id})*/
          this.configs.report_tab = 1
        } else {
          // Lógica para quando a ação for a escolha de opção opt-in ou opt-out
          if (engagement_type == 1) {
            await this.$store.dispatch("getLeadsReportsEngagementIn", {channel_id: this.leads.reports.channel_id})
            await this.$store.dispatch("getLeadsReportsEngagementInGraph", {channel_id: this.leads.reports.channel_id})
            this.configs.report_tab = 1
          }
          else {
            await this.$store.dispatch("getLeadsReportsEngagementOut")
            await this.$store.dispatch("getLeadsReportsEngagementOutGraph", {channel_id: this.leads.reports.channel_id})
            this.configs.report_tab = 2
          }
        }
      }
    },

    exportOperatorsReportsExcel() {
      this.$store.dispatch('exportOperatorsDownload')
    },

    // async searchChatBot() {
    //   if (this.reports.report_main_menu_chatbot_clicks.length > 0 && this.reports.report_submenu_chatbot_clicks.length > 0) {
    //     await this.$store.dispatch('getReportMainChatBot', this.reports.filter_report_chatbot)
    //     await this.$store.dispatch('setReportSubmenuChatBot', this.reports.filter_report_chatbot)
    //     this.reports.search_report_chatbot = true
    //   } else if (this.reports.report_main_menu_chatbot_clicks.length > 0 && this.reports.report_submenu_chatbot_clicks.length === 0) {
    //     await this.$store.dispatch('getReportMainChatBot', this.reports.filter_report_chatbot)
    //     this.reports.search_report_chatbot = true
    //   }
    // },

    searchChatbot() {
      this.$store.dispatch('getBots', { channel_id: this.reports.filter_report_chatbot.channel_id });
      this.$store.dispatch('getReportMainChatBot', this.reports.filter_report_chatbot);
    },
  },
  
  watch: {
    $route(to, from) {
      this.isopenModalVisible = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    this.isopenModalVisible = false;
    next();
  }
};
</script>


